import axios from "axios"
import url from "../utils/url";

export const postearArchivoAutogestion = async (archivo) => {
    return await axios.post(`${url}/api/autogestion`, archivo);
}



